import { navLinks } from "../../../mocks/communityData";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-background-100 pt-14">
      {/* 顶部 CTA 条 */}
      <div className="mx-auto w-full max-w-6xl px-4 pb-12 md:px-6">
        <div className="seed-stripe h-2.5 w-full rounded-full opacity-80" />
        <div className="mt-10 grid grid-cols-1 gap-10 md:grid-cols-4">
          {/* 品牌 */}
          <div className="md:col-span-2">
            <a href="#home" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 font-display text-lg text-white">瓜</span>
              <span className="font-display text-xl text-foreground-900">
                吃瓜<span className="text-primary-500">同好会</span>
              </span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              免费吃瓜社区聚集地，瓜友一起讨论互动，分享最新瓜料与内幕。同好圈子不冷场，热门话题天天有，随时加入随时聊，吃瓜不孤单。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["免费吃瓜", "同好社区", "话题讨论", "聚集地"].map((t) => (
                <span key={t} className="rounded-full bg-background-200 px-3 py-1 text-xs font-medium text-foreground-600">
                  #{t}
                </span>
              ))}
            </div>
          </div>

          {/* 快速导航 */}
          <div>
            <h4 className="text-sm font-bold text-foreground-900">快速导航</h4>
            <ul className="mt-4 space-y-3">
              {navLinks.map((item) => (
                <li key={item.key}>
                  <a href={item.anchor} className="text-sm text-foreground-600 transition hover:text-primary-500">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 联系我们 */}
          <div>
            <h4 className="text-sm font-bold text-foreground-900">联系我们</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400" /> melon@example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-400" /> 全年无休 · 随时在线
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-community-line text-primary-400" /> 面向全体瓜友开放
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* 版权栏 */}
      <div className="border-t border-background-200">
        <div className="mx-auto flex w-full max-w-6xl flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-6">
          <p>© {year} 吃瓜同好会 · 免费吃瓜社区聚集地</p>
          <p className="flex items-center gap-1">
            理性吃瓜 · 友善交流 <i className="ri-heart-3-fill text-primary-400" />
          </p>
        </div>
      </div>
    </footer>
  );
}